import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { SafeHtmlPipe } from '../pipes/SafeHtml.pipe';
import { BrnTooltipTriggerDirective } from '@spartan-ng/ui-tooltip-brain';
import { TooltipArrowPositionDirective } from '../directive/tooltip-arrow-position.directive';
import { ClickOutsideDirective } from '../directive/clickoutside.directive';
import { baseCssConfigStyle } from '@finxone-platform/shared/sys-config-types';

@Component({
  standalone: true,
  selector: 'finxone-platform-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    SafeHtmlPipe,
    BrnTooltipTriggerDirective,
    TooltipArrowPositionDirective,
    ClickOutsideDirective,
  ],
})
export class TooltipComponent {
  @Input() content = '';
  @Input() isPreview = false;
  @Input() textStyleClass = '';
  @Input() borderRadiusClass = '';
  @Input() set tooltipIcon(icon: string | undefined) {
    this.icon = icon ?? 'info';
  }
  @Input() infoIconStyles: baseCssConfigStyle;

  public icon = 'info';

  @ViewChild('triggerElement') triggerElementRef?: ElementRef<HTMLElement>;
  @ViewChild('tooltipTrigger') tooltipTrigger?: BrnTooltipTriggerDirective;

  public get tooltipClasses(): string {
    const baseClasses =
      'fade-in-0 zoom-in-95 data-[state=open]:animate-in data-[side=below]:slide-in-from-top-2 data-[side=above]:slide-in-from-bottom-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2';
    return `${baseClasses} finx-tooltip ${this.borderRadiusClass} ${this.textStyleClass}`.trim();
  }

  public handleClickOutside(event: Event) {
    if (this.isPreview || !this.tooltipTrigger) return;

    const target = event.target as HTMLElement;

    // Check if the click happened inside the tooltip overlay container
    // Because the tooltip overlay is appended to the body, the clickOutside directive
    // sees it as an "outside" click, so we need to manually ignore it here.
    const isInsideTooltip = target.closest && target.closest('.cdk-overlay-container') !== null;

    if (!isInsideTooltip) {
      // It's a genuine outside click, hide the tooltip
      this.tooltipTrigger.hide(0);
    }
  }
}
